import "./AppLayout.css";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { PlanSessionProvider } from "../features/plan3d/PlanSession";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/SideBar/Sidebar";
import Topbar from "../components/Topbar/Topbar";
import { ConsultantProvider } from "../features/consultant/ConsultantContext";
import FloatingConsultant from "../features/consultant/FloatingConsultant";

const AppLayout = () => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isOpen, setIsOpen] = useState(false);

  // Escuchar cambio de tamaño para ajustar sidebar
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsOpen(false); // En móvil cerrado por defecto
      }
    };

    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <ConsultantProvider>
      <div className="app-layout">
        {/* Mostrar sidebar solo si está abierto */}
        <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />

        <div className="layout-right">
          <Topbar toggle={toggle} />
          <main className="layout-content">
            <PlanSessionProvider key={`${currentUser?.id_user || 'anonymous'}-${!!currentUser?.accessToken}`}>
              <Outlet />
            </PlanSessionProvider>
          </main>
        </div>
        <FloatingConsultant />
      </div>
    </ConsultantProvider>
  );
};

export default AppLayout;
